import React from "react";
import { useTranslation } from "react-i18next";

import { Box, Flex, Heading, Text } from "@chakra-ui/react";

import ChangePassword from "../ChangePassword";
import MyAccountForm from "../MyAccountForm";

const DetailsView = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Flex
        flexDirection={{ base: "column", lg: "row" }}
        bg="greyscale.100"
        p={{ base: 4, md: 6 }}
        borderRadius="lg"
        rowGap={{ base: 6, md: 8 }}
      >
        <Box w={{ base: "100%", lg: "33%" }}>
          <Heading variant="h5">{t("my_account.details.your_details")}</Heading>
          <Text fontSize="m" color="primary.700">
            {t("my_account.details.provide_us_with_information")}
          </Text>
        </Box>
        <Box w={{ base: "100%", lg: "67%" }}>
          <MyAccountForm responsive={true} actionLabel={t("my_account.details.update_my_details")} />
        </Box>
      </Flex>
      <ChangePassword />
    </Box>
  );
};

export default DetailsView;
